// extracted by mini-css-extract-plugin
export default {"search-buttons__label":"search-buttons__label__IUqtq","search-buttons":"search-buttons__iAWic"};